import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAutoFlash: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAutoFlash"><Path d="M13.9984 0.550293L2.22266 15.9219H9.99844V23.5591L21.7198 7.5469H13.9984V0.550293Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21.5502 14L23.5002 23H21.4002L21.1202 21.5H17.7602L16.8002 23H14.3987L20.2002 14H21.5502ZM19.046 19.5H20.6916L20.2802 17.5801L19.046 19.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAutoFlash;
